import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { UserStateContext } from "@/contexts/UserStateProvider";
import { ChartAreaIcon, ChevronDown, InfoIcon, Settings } from "lucide-react";
import { useContext } from "react";
import { ChartSettings } from "./chart-settings";

export const ChartSettingsPopover = () => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="border-dashed">
          <ChartAreaIcon className="mr-2 h-4 w-4" />
          Chart Settings
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <div className="flex flex-col gap-6">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">Chart Settings</h4>
            <p className="text-sm text-muted-foreground">
              Customize how the chart data is displayed.
            </p>
          </div>
          <ChartSettings />
        </div>
      </PopoverContent>
    </Popover>
  );
};
